module.exports = __webpack_public_path__ + "img/product_47.d10d0b4.webp";